import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Menu.css';
import { APP_VERSION } from '../version';
import Icon from '@mdi/react';
import { mdiAccountOutline, mdiBankOutline, mdiCalendarOutline, mdiChartLine, mdiHome, mdiInvoiceImportOutline, mdiInvoiceListOutline, mdiLabelOutline, mdiPin, mdiPinOff } from '@mdi/js';
import useIsMobile from '../hooks/useIsMobile';
import LensEuroIcon from './LensEuroIcon';

const Menu = ({ isMenuOpen, toggleMenu, isMenuPinned = true, toggleMenuPin = () => {}, closeMenu = () => {}, onOpenAccountPanel = () => {}, allowedPages = [] }) => {

  const isMobile = useIsMobile();

  const canSee = (page) => allowedPages.includes(page);

  // Pinned (desktop) menu stays open across navigation; unpinned/overlay and
  // mobile menus close after each navigation.
  const handleNavClick = () => {
    if (isMobile || !isMenuPinned) {
      closeMenu();
    }
  };

  const pinButtonTitle = isMenuPinned ? 'Unpin menu (overlay mode)' : 'Pin menu open';

  return (
    <div className={`menu ${isMenuOpen ? 'expanded' : ''} ${isMenuPinned ? 'pinned' : 'overlay'}`}>
      <div className='title-bar'>
        <button
          type='button'
          className='menu-pin-button'
          onClick={toggleMenuPin}
          aria-label={pinButtonTitle}
        >
          <Icon path={isMenuPinned ? mdiPin : mdiPinOff} size={0.9} />
        </button>
      </div>
      <ul>
        <li><Link to="/" onClick={handleNavClick}><Icon path={mdiHome} size={1} /> Home</Link></li>
        {canSee('investments') && (
          <li><Link to="/investments" onClick={handleNavClick}><Icon path={mdiChartLine} size={1} /> Investments</Link></li>
        )}
        <hr className="separator" />
        {canSee('transactions') && (
          <li data-tour="menu-transactions"><Link to="/transactions" onClick={handleNavClick}><Icon path={mdiInvoiceListOutline} size={1} /> Transactions</Link></li>
        )}
        {canSee('import-transactions') && (
          <li><Link to="/import-transactions" onClick={handleNavClick}><Icon path={mdiInvoiceImportOutline} size={1} /> Import Statement</Link></li>
        )}
        <hr className="separator" />
        {canSee('manage-accounts') && (
          <li data-tour="menu-manage-accounts"><Link to="/manage-accounts" onClick={handleNavClick}><Icon path={mdiBankOutline} size={1} /> Manage Accounts</Link></li>
        )}
        {canSee('manage-subjects') && (
          <li data-tour="menu-manage-subjects"><Link to="/manage-subjects" onClick={handleNavClick}><Icon path={mdiAccountOutline} size={1} /> Manage Subjects</Link></li>
        )}
        {canSee('manage-categories') && (
          <li data-tour="menu-manage-categories"><Link to="/manage-categories" onClick={handleNavClick}><Icon path={mdiLabelOutline} size={1} /> Manage Categories</Link></li>
        )}
        {canSee('manage-recurrences') && (
          <li data-tour="menu-manage-recurrences"><Link to="/manage-recurrences" onClick={handleNavClick}><Icon path={mdiCalendarOutline} size={1} /> Manage Recurrences</Link></li>
        )}
      </ul>
      <div className="menu-footer">
        <h1><span className="menu-app-icon"><LensEuroIcon size={1.1} /></span> Money Lens</h1>
        <div className="version-info">
          v{APP_VERSION}
        </div>
      </div>
    </div>
  );
};

export default Menu;